import {observer} from 'mobx-react';
import {autoinject, bind, inject, NotificationList, Topbar} from 'Mri.Web.Common';
import * as React from 'react';
import {AccountStore, NO_ACTIVE_PRESET} from '../Account/AccountStore';
import {AppStore} from './AppStore';
import {UserMenu} from './UserMenu';
import {action, computed} from "mobx";
import {BsXCircle} from "react-icons/bs";

export interface IHeaderProps {
    readonly onMenuLinkClick: any;
    readonly history: any; // Hack to get component to rerender on location change
}

@autoinject
@observer
export class Header extends React.Component<IHeaderProps> {
    public render() {
        return (
            <Topbar onMenuLinkClick={this.props.onMenuLinkClick} hide={this.appStore.hiddenHeader}>
                <div className="py-0 ms-auto d-flex">
                    {this.accountStore.storage.displaysPreference == 'list' &&
                        <div className="d-none d-md-flex" style={{ minWidth: 250 + "px" }}>
                            {this.accountStore.storage.activeColumnPreset && (
                                <div>
                                    Columns: <strong>{this.accountStore.storage.activeColumnPreset}</strong>
                                </div>
                            )}
                            {this.accountStore.storage.activeStickyPreset && (
                                <div>
                                    Stickies: <strong>{this.accountStore.storage.activeStickyPreset}</strong>
                                </div>
                            )}
                        </div>
                    }

                    {this.accountStore.storage.displaysPreference == 'grid' &&
                        <div className="d-none d-md-flex align-items-center" style={{ minWidth: 250 + "px" }}>
                            {this.gridColumnPreset && (
                                <div>
                                    Active Preset: <strong>{this.gridColumnPreset}</strong>
                                    <button onClick={() => this.unsetPreset()} className="btn btn-link d-inline-block">
                                        <BsXCircle className="text-danger" />
                                    </button>
                                </div>
                            )}
                        </div>
                    }
                    
                    <NotificationList />
                    <UserMenu />
                </div>
            </Topbar>
        );
    }
    
    @bind
    @action
    private unsetPreset() {
        let columns = this.appStore.gridRef?.api.getColumnState();
        if(columns){
            this.accountStore.storage.noActivePresetGridColumns = columns;
        }
        
        this.accountStore.tabStorage.activeGridColumnPreset = NO_ACTIVE_PRESET;
        this.accountStore.storage.activeGridColumnPreset = NO_ACTIVE_PRESET;
    }
    
    @computed
    private get gridColumnPreset(){
        let gridColumnPresets = this.accountStore.storage.gridColumnPresets || []
        let preset = this.accountStore.tabStorage.activeGridColumnPreset;
        let activePreset = gridColumnPresets.find(p => p.name == preset);
        return activePreset?.name || '';
    }

    @inject
    private appStore!: AppStore;
    @inject
    private accountStore!: AccountStore;
}
